import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "@/lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await login(email, password);
      localStorage.setItem("ms_token", res.token);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Connexion échouée");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-6">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm">
        <div className="w-12 h-12 bg-[#0044ff] flex items-center justify-center mb-8">
          <Lock className="w-5 h-5" />
        </div>
        <h1 className="font-display font-black uppercase tracking-tighter text-4xl">Espace admin</h1>
        <p className="text-white/50 text-sm mt-2 mb-10">MerchStudio · gestion des devis</p>

        <label className="font-mono text-xs uppercase tracking-widest text-white/50 block mb-2">Email</label>
        <input
          type="email"
          data-testid="admin-email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-transparent border border-white/20 px-4 py-3 mb-5 outline-none focus:border-[#0044ff] transition-colors"
        />
        <label className="font-mono text-xs uppercase tracking-widest text-white/50 block mb-2">Mot de passe</label>
        <input
          type="password"
          data-testid="admin-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-transparent border border-white/20 px-4 py-3 mb-6 outline-none focus:border-[#0044ff] transition-colors"
        />
        {error && <p data-testid="admin-error" className="text-red-400 text-sm mb-4">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-submit"
          className="w-full bg-white text-black py-4 font-bold uppercase tracking-widest text-sm hover:bg-[#0044ff] hover:text-white transition-colors disabled:opacity-50"
        >
          {loading ? "Connexion…" : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
